<template>
  <b-form-group
    v-if="component"
    :label="title"
    :label-for="id"
  >
    <component
      :id="id"
      :is="component"
      :data="data"
      :value="value"
      @input="updateValue"
    ></component>
  </b-form-group>
</template>

<style lang="scss" scoped>
</style>

<script>
import get from 'lodash/get'

import MonthsInYear from './MonthsInYear'
import DateRange from './DateRange'
import Select from './Select'
import SelectWithToggle from "./SelectWithToggle";

export default {
  name: 'FilterComponent',

  components: {
    MonthsInYear,
    DateRange,
    Select,
    SelectWithToggle
  },

  props: {
    filter: {
      type: Object,
      default () {
        return null
      }
    },

    value: {
      type: [
        String,
        Number,
        Object
      ]
    }
  },

  computed: {
    id () {
      return get(this.filter, 'filter')
    },

    component () {
      return get(this.filter, 'component')
    },

    title () {
      return get(this.filter, 'title')
    },

    data () {
      return get(this.filter, 'data')
    }
  },

  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>
